import React, { useState } from "react";
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import AppSidebar, { SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED } from "./AppSidebar";
import AppTopbar from "./AppTopbar";
import MobileBottomNav from "./MobileBottomNav";
import { ErrorBoundary } from "../ui";
import InstallPrompt from "./InstallPrompt";
import PushPrompt from "./PushPrompt";
import ChatAssistant from "../AI/ChatAssistant";

export default function AppShell({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(() => {
    const saved = localStorage.getItem("sidebarOpen");
    return saved === null ? true : saved === "true";
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggle = () => {
    if (isMobile) setMobileOpen((v) => !v);
    else {
      const next = !open;
      setOpen(next);
      localStorage.setItem("sidebarOpen", String(next));
    }
  };

  // Close the temporary drawer after a nav tap on mobile — otherwise it stays open
  // covering the page the user just navigated to.
  const closeMobile = () => setMobileOpen(false);

  const leftOffset = isMobile ? 0 : open ? SIDEBAR_WIDTH : SIDEBAR_WIDTH_COLLAPSED;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default", overflowX: "hidden" }}>
      {!isMobile && <AppSidebar open={open} onToggle={toggle} />}
      {isMobile && <AppSidebar open={mobileOpen} onToggle={toggle} mobile onNavigate={closeMobile} />}
      <AppTopbar onMenuClick={toggle} leftOffset={leftOffset} />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,           // critical: allows flex child to shrink below content width
          width: "100%",
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          pb: { xs: 10, sm: 2 },
        }}
      >
        <Toolbar />
        <ErrorBoundary>
          <Box sx={{ flex: 1, minWidth: 0, width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
            {children}
          </Box>
        </ErrorBoundary>
      </Box>
      {isMobile && <MobileBottomNav onMore={() => setMobileOpen(true)} />}
      <InstallPrompt />
      <PushPrompt />
      <ChatAssistant />
    </Box>
  );
}
